<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>THE STORY DEVOTIONAL</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ct1p" id="p0027-01-0"><a id="page21"></a><a href="#/contents#fn_20" id="sn_20">DAY 20</a></p>
<p class="ct1"><a href="#/contents#fn_20">“NEVER AGAIN!”</a></p>
<p class="ext"><span><i>God said to Noah . . . “I now establish my covenant with you and with your descendants after you . . . Never again will all life be destroyed by the waters of a flood” . . .</i></span></p>
<p class="ext1"><span><i>And God said . . . “I have set my rainbow in the clouds, and it will be the sign of the covenant.”</i></span></p>
<p class="txr"><span><span class="small">GENESIS</span> 9:8–13, 15</span></p>
<p class="tx1" id="p0027-04-5"><span class="dcap">P</span>inky promise!” “Cross my heart!” Somehow just saying, “I promise” doesn’t seem sufficient. As if there were a gray area when it comes to keeping a promise. But there is no gray area: a promise is kept, or it’s not. And God always keeps his promises. Always.</p>
<p class="tx">Consider the promise God made in Genesis 9. The once angry, heartbroken God had exercised his judgment and sent a flood that covered the earth. After the waters receded, God made this promise: “Never again will all life be destroyed by the waters of a flood.” </p>
<p class="tx">The Almighty didn’t need to do anything to reinforce the validity of his eternal promise—but he chose to: “I have set my rainbow in the clouds, and it will be the sign of the covenant between me and the earth.”</p>
<p class="tx">The physical beauty of a rainbow spanning the sky is just part of the story. The more important part is the spiritual beauty of God’s faithfulness to us, his unfaithful people.</p>
<p class="tx3">GOD PROMISES UNFAITHFUL PEOPLE HIS UNENDING FAITHFULNESS.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter23.vue?42837e38